module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ibox"
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h5', [_vm._v("Privacy")]), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "All respondents",
      "placement": "left"
    }
  }, [_c('span', {
    staticClass: "pull-right text-muted text-right count"
  }, [_c('em', [_vm._v("n")]), _vm._v(" = " + _vm._s(_vm.respondents) + "\n        ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("\n      Statistics for opt-ins / permission to process / age data.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content privacy-list-content"
  }, [_c('div', {
    staticClass: "pull-right total-display"
  }, [_c('el-radio-group', {
    attrs: {
      "size": "mini"
    },
    model: {
      value: (_vm.selectedTotalDisplay),
      callback: function($$v) {
        _vm.selectedTotalDisplay = $$v
      },
      expression: "selectedTotalDisplay"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "percentage"
    }
  }, [_vm._v("Percentage")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "total"
    }
  }, [_vm._v("Total")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isloading),
      expression: "isloading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.getOptins,
      "fit": true,
      "empty-text": 'No Privacy Data',
      "max-height": "400",
      "row-key": "type",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Type",
      "class-name": 'client-link'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.type) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Yes"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.totalDisplay(scope.row.count.yes)) + "\n          ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "No"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(_vm.totalDisplay(scope.row.count.no)) + "\n          ")]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "ibox-tools el-download-btn"
  }, [_c('el-button', {
    staticClass: "ibox-tool-btn",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": ""
    },
    on: {
      "click": _vm.getPrivacyTypes
    }
  }, [_vm._v("\n        Export\n      ")])], 1)]), _vm._v(" "), (_vm.downloadPrivacyVisible) ? _c('privacy-report-dialog', {
    attrs: {
      "privacy": _vm.getOptins,
      "isVisible": _vm.downloadPrivacyVisible
    },
    on: {
      "onVisibleChanged": _vm.handleDownloadPrivacyVisibilityChanged
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38974c92","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/privacy/PrivacyDataList.vue
// module id = 3223
// module chunks = 3